import { Routes, Route, Navigate } from "react-router-dom";
import SubscriptionsContainer from "@components/Subscriptions/SubscriptionsContainer";
import PaymentMethodsContainer from "@components/PaymentMethods/PaymentMethodsContainer";
import PurchaseContainer from "@components/Purchases/PurchaseContainer";
import { usePaymentMethodContext } from "@context/PaymentMethodContext";

const RouteList = () => {
  const { hasZuoraSub, arePaymentMethodsLoading } = usePaymentMethodContext();

  const paymentMethodsElement = !arePaymentMethodsLoading && !hasZuoraSub
    ? <Navigate to="/subscriptions" replace />
    : <PaymentMethodsContainer />;

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/subscriptions" replace />} />
      <Route
        path="/subscriptions"
        element={
          <SubscriptionsContainer />
        }
      />
      <Route
        path="/payment-methods"
        element={paymentMethodsElement}
      />
      <Route
        path="/purchases"
        element={
          <PurchaseContainer />
        }
      />
      <Route path="*" element={<Navigate to="/subscriptions" replace />} />
    </Routes>
  );
};

export default RouteList;
